import React from "react";

const BUSINESS_ADDRESS = "1280 Chemin de la Sabaillane, 31370 Lahage";
const BUSINESS_PHONE = "06 45 21 95 85";
const BUSINESS_PHONE_LINK = "tel:+33645219585";
const GOOGLE_MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(BUSINESS_ADDRESS)}`;

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-header">
          <span className="subtitle">Disponibilité Totale</span>
          <h2 className="title">Nous Contacter</h2>
          <div className="title-accent"></div>
        </div>

        <div className="contact-grid">
          <div className="info-side">
            <div className="contact-card">
              <div className="icon-wrapper">📍</div>
              <div className="card-content">
                <h3>Adresse</h3>
                <p>{BUSINESS_ADDRESS}</p>
                <a href={GOOGLE_MAPS_LINK} target="_blank" rel="noopener noreferrer" className="card-action">
                  Lancer le GPS →
                </a>
              </div>
            </div>

            <div className="contact-card">
              <div className="icon-wrapper">📞</div>
              <div className="card-content">
                <h3>Téléphone</h3>
                <p>Besoin d'un dépannage urgent ?</p>
                <a href={BUSINESS_PHONE_LINK} className="card-phone">
                  {BUSINESS_PHONE}
                </a>
              </div>
            </div>

            <div className="contact-card">
              <div className="icon-wrapper">🕒</div>
              <div className="card-content">
                <h3>Horaires</h3>
                <p className="status-badge">Ouvert 24h/24 & 7j/7</p>
                <p className="status-text">Intervention rapide en Haute-Garonne</p>
              </div>
            </div>
          </div>

          <div className="map-side">
            <div className="map-frame">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2896.888225311281!2d1.0779789765220436!3d43.442050366061245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a9378b7d412b7d%3A0x5b401e98be76962e!2sChristophe%20D%C3%A9panne!5e0!3m2!1sfr!2sfr!4v1775073944837!5m2!1sfr!2sfr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localisation Christophe Dépanne avec avis"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .contact-section {
          padding: 100px 20px;
          background-color: #f1f5f9;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .contact-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .contact-header .subtitle {
          text-transform: uppercase;
          letter-spacing: 3px;
          color: #1A365D;
          font-weight: 700;
          font-size: 0.9rem;
          display: block;
          margin-bottom: 10px;
        }

        .contact-header .title {
          font-size: 3rem;
          font-weight: 800;
          color: #1a202c;
          margin: 0;
        }

        .contact-header .title-accent {
          width: 50px;
          height: 4px;
          background: #1A365D;
          margin: 20px auto 0;
          border-radius: 2px;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
          gap: 40px;
          align-items: stretch;
        }

        .info-side {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .contact-card {
          background: white;
          padding: 30px;
          border-radius: 20px;
          display: flex;
          gap: 25px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.05);
          transition: transform 0.3s ease;
        }

        .contact-card:hover {
          transform: translateX(10px);
        }

        .icon-wrapper {
          width: 60px;
          height: 60px;
          background: #f1f5f9;
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.8rem;
          flex-shrink: 0;
        }

        .card-content h3 {
          margin: 0 0 10px 0;
          font-size: 1.3rem;
          color: #1A365D;
          font-weight: 700;
        }

        .card-content p {
          margin: 0 0 10px 0;
          color: #4a5568;
          font-size: 1.1rem;
          line-height: 1.5;
        }

        .card-action {
          color: #3182ce;
          text-decoration: none;
          font-weight: 700;
          font-size: 1rem;
          display: inline-block;
          margin-top: 5px;
        }

        .card-action:hover {
          text-decoration: underline;
        }

        .card-phone {
          font-size: 1.8rem;
          color: #1a202c;
          text-decoration: none;
          font-weight: 800;
          display: block;
          margin-top: 5px;
          transition: color 0.3s ease;
        }

        .card-phone:hover {
          color: #3182ce;
        }

        .status-badge {
          display: inline-block;
          background: #48bb78;
          color: white;
          padding: 4px 12px;
          border-radius: 50px;
          font-size: 0.9rem !important;
          font-weight: 700;
          margin-bottom: 10px !important;
        }

        .map-side {
          min-height: 500px;
        }

        .map-frame {
          width: 100%;
          height: 100%;
          border-radius: 25px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0,0,0,0.1);
          background: white;
          border: 8px solid white;
        }

        @media (max-width: 968px) {
          .contact-grid {
            grid-template-columns: 1fr;
          }
          .map-side {
            min-height: 400px;
          }
        }

        @media (max-width: 480px) {
          .contact-header .title { font-size: 2.2rem; }
          .contact-card { padding: 20px; flex-direction: column; gap: 15px; }
          .card-phone { font-size: 1.5rem; }
          .icon-wrapper { width: 50px; height: 50px; font-size: 1.5rem; }
        }
      `}</style>
    </section>
  );
};

export default Contact;